export const drawerWidth = 300;

// TODO: sync this with the actual height of the AppBar as defined in @tribe/react-mui-overheid-thema
export const appBarHeight = 64;
